import React from 'react';
import Leavedatescal from './Leavedatescal';

const LeaveTab = () => {
    return (
        <div data-testid="leave-tab-container">
            <Leavedatescal />
        </div>
    );
};

export default LeaveTab;

